module.exports = __webpack_public_path__ + "static/media/EAT_graphic.6553e679.svg";